import React, { useEffect, useState } from "react";
import SurveysService from "../../services/surveys.service";
import SurveyResponseOffcanvas from "./SurveyResponseOffcanvas";

import { usePermissionsStore } from "../permissions/permissions_store";
import { canReadSurveyResponse } from "./response-permissions";

export default function SurveyResponseViewer({ selection, onClose }) {
  const { canView } = usePermissionsStore();
  const allowed = canReadSurveyResponse(canView);
  const surveyId = selection?.surveyId == null ? null : String(selection.surveyId);
  const responseId = selection?.responseId == null ? null : String(selection.responseId);
  const key = selection ? `${surveyId}:${responseId}` : null;
  const [refresh, setRefresh] = useState(0);
  const [loaded, setLoaded] = useState({});

  useEffect(() => {
    if (!allowed || !surveyId || !responseId) return;
    let active = true;
    const requestKey = `${surveyId}:${responseId}`;
    setLoaded({ key: requestKey, loading: true });
    SurveysService.getSurveyResponse(surveyId, responseId).then(({ data }) => {
      if (!active) return;
      const result = data?.survey_results?.find((response) => String(response.survey_results_id) === responseId);
      setLoaded(result ? { key: requestKey, survey: data, result } : { key: requestKey, error: "This survey response is unavailable." });
    }).catch((error) => {
      if (active) setLoaded({ key: requestKey, error: error.response?.status === 404 ? "This survey response is unavailable." : "Unable to load the survey response. Please try again." });
    });
    return () => { active = false; };
  }, [surveyId, responseId, refresh, allowed]);

  if (!selection || !allowed) return null;
  const current = loaded.key === key ? loaded : { loading: true };
  return <SurveyResponseOffcanvas open survey={current.survey} result={current.result}
    loading={!!current.loading} error={current.error} onClose={onClose}
    onRetry={() => setRefresh((value) => value + 1)} />;
}
